// Starting points for new call flows, filled with the company's real data.

const n = (id, type, x, y, data) => ({ id, type, position: { x, y }, data });
const e = (source, sourceHandle, target) => ({ id: `e-${source}-${sourceHandle}-${target}`, source, sourceHandle, target, targetHandle: 'input' });

/** Members the templates ring: owners and admins with a mobile number (everyone with one if there are none). */
export function defaultMembers(team) {
  const reachable = team.filter((t) => t.phone);
  const leads = reachable.filter((t) => t.role === 'owner' || t.role === 'admin');
  return (leads.length ? leads : reachable).map((t) => t.user_id);
}

export function standardIvr(company, team) {
  const members = defaultMembers(team);
  return {
    nodes: [
      n('start', 'start', 40, 220, { label: 'Call Comes In', phoneNumber: '' }),
      n('greeting', 'playAudio', 320, 220, { label: 'Welcome Greeting', sourceType: 'text', voice: 'female', audioUrl: '', message: `Thank you for calling ${company}.` }),
      n('menu', 'ivrMenu', 600, 220, {
        label: 'Main Menu', message: 'For sales, press 1. For support, press 2. To leave a message, press 3.',
        options: [{ key: '1', label: 'Sales' }, { key: '2', label: 'Support' }, { key: '3', label: 'Voicemail' }],
      }),
      n('hours', 'officeHours', 920, 40, { label: 'Sales Hours', timezone: 'Asia/Kolkata', hours: { start: '09:00', end: '18:00' }, days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat'] }),
      n('sales', 'team', 1220, 0, { label: 'Sales Team', queueName: 'Sales', strategy: 'ring-all', members, ringTimeout: 25 }),
      n('support', 'team', 920, 300, { label: 'Support Team', queueName: 'Support', strategy: 'linear', members, ringTimeout: 20 }),
      n('voicemail', 'voicemail', 1220, 420, { label: 'Voicemail', message: 'Sorry, nobody can take your call right now. Please leave a message after the beep.', emailDelivery: '' }),
      n('end', 'hangUp', 1520, 220, { label: 'End Call', reason: 'completed' }),
    ],
    edges: [
      e('start', 'output', 'greeting'), e('greeting', 'output', 'menu'),
      e('menu', 'key-1', 'hours'), e('menu', 'key-2', 'support'), e('menu', 'key-3', 'voicemail'), e('menu', 'no-input', 'voicemail'),
      e('hours', 'open', 'sales'), e('hours', 'closed', 'voicemail'),
      e('sales', 'answered', 'end'), e('sales', 'no-answer', 'voicemail'),
      e('support', 'answered', 'end'), e('support', 'no-answer', 'voicemail'),
      e('voicemail', 'output', 'end'),
    ],
  };
}

export function simpleRouting(company, team) {
  const members = defaultMembers(team);
  return {
    nodes: [
      n('start', 'start', 40, 200, { label: 'Call Comes In', phoneNumber: '' }),
      n('hours', 'officeHours', 320, 200, { label: 'Business Hours', timezone: 'Asia/Kolkata', hours: { start: '09:00', end: '18:00' }, days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat'] }),
      n('team', 'team', 620, 80, { label: 'Ring the Team', queueName: 'Team', strategy: 'ring-all', members, ringTimeout: 30 }),
      n('closed', 'playAudio', 620, 340, { label: 'After Hours', sourceType: 'text', voice: 'female', audioUrl: '', message: `Thanks for calling ${company}. We're closed right now.` }),
      n('voicemail', 'voicemail', 920, 240, { label: 'Voicemail', message: 'Please leave a message after the beep and we will call you back.', emailDelivery: '' }),
      n('end', 'hangUp', 1220, 200, { label: 'End Call', reason: 'completed' }),
    ],
    edges: [
      e('start', 'output', 'hours'), e('hours', 'open', 'team'), e('hours', 'closed', 'closed'),
      e('team', 'answered', 'end'), e('team', 'no-answer', 'voicemail'), e('closed', 'output', 'voicemail'), e('voicemail', 'output', 'end'),
    ],
  };
}

export const blank = () => ({ nodes: [n('start', 'start', 80, 200, { label: 'Call Comes In', phoneNumber: '' })], edges: [] });

export const TEMPLATES = [
  ['standard', 'Standard IVR', 'Greeting, then a menu: sales, support or voicemail', standardIvr],
  ['simple', 'Simple routing', 'Office hours, ring the team, then voicemail', simpleRouting],
  ['blank', 'Blank', 'Start from just "Call Comes In"', blank],
];
